<template>
  <div>
    <div class="row" v-if="value">
      <div class="col-md-12 form-group">
        <div v-if="value.length > 1">
          <div v-for="(row, index) in value" :key="'btn_' + index" class="divmultilangbtn">
            <button
              class="btnmultilang btn btn-primary btn-xs"
              :class="[row.tblLanguageShortCode === langchoice ? 'mutlilangactive' : '']"
              @click="changelangchoice(row.tblLanguageShortCode)"
            >
              {{ row.tblLanguageShortCode }}
            </button>
          </div>
        </div>
        <div v-for="(row, index) in value" :key="'textbox_' + index">
          <div v-show="row.tblLanguageShortCode === langchoice">
            <XVtextarea
              :disabled="disabled"
              type="text"
              :id="'Textbox_' + index"
              :rows="rows"
              :maxlength="maxlength"
              :value="row.tblTextUserContents"
              :ref="'input' + row.tblLanguageID"
              v-on:input="(e) => formvaluechanged(e, row)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { util } from 'pevueglobal'
export default {
  name: 'XVmultilanguagetextbox',
  props: {
    rows: {
      type: Number,
      default: 1,
    },
    maxlength: {
      type: Number,
    },
    value: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      langchoice: '',
    }
  },
  mounted: function () {
    this.setlangchoice()
  },
  methods: {
    setlangchoice() {
      this.langchoice = this.value[0].tblLanguageShortCode
    },
    changelangchoice(lang) {
      this.langchoice = lang
    },
    formvaluechanged: function (value, row) {
      this.value.forEach((mltxb) => {
        if (mltxb.tblLanguageID === row.tblLanguageID) {
          mltxb.tblTextUserContents = value
        }
      })
      this.$emit('input', this.value) // wat de v-model moet gaan worden (update)
    },
  },
  computed: {},
}
</script>


<style scoped>
.btnmultilang {
  width: '25px';
  border-color: #ccc;
  border-radius: 0;
  border: 1px solid #ccc;
  background-color: #fff;
  background-image: none;
}
.btnmultilang:hover {
  border-color: #ccc;
  background-color: #ccc !important;
}
.divmultilangbtn {
  display: inline-block;
}
.mutlilangactive {
  background-color: #ccc !important;
}
.text {
  border-color: #ccc;
}
</style>

